import { Paper, Table } from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { memo } from 'react';

import classes from './list.module.css';

export const List = memo(_List);
List.displayName = 'List';

function _List({
	title,
	w,
	children,
}: PropsWithChildren<{ title: string; w?: React.CSSProperties['width'] }>) {
	return (
		<Paper styles={{ root: { overflow: 'hidden' } }} shadow='md' w={w}>
			<Table withRowBorders>
				{title && title !== '' && (
					<Table.Thead>
						<Table.Tr className={classes.header}>
							<Table.Th>{title}</Table.Th>
						</Table.Tr>
					</Table.Thead>
				)}

				<Table.Tbody>{children}</Table.Tbody>
			</Table>
		</Paper>
	);
}
